import { useEffect, useState } from 'react';
import Modal from './Modal';

const ConfirmDialog = ({
  isOpen,
  title = 'Confirmer l’action',
  description,
  children,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  onConfirm,
  onCancel,
  tone = 'primary',
  confirmDisabled = false,
}) => {
  const [confirming, setConfirming] = useState(false);
  const confirmColors = {
    primary: 'bg-primary-600 hover:bg-primary-700 text-white',
    danger: 'bg-red-600 hover:bg-red-700 text-white'
  };
  const busy = confirmDisabled || confirming;

  useEffect(() => {
    if (!isOpen) setConfirming(false);
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      maxWidth="max-w-md"
    >
      <div className="space-y-6">
        {description && (
          <p className="text-sm text-gray-600 leading-relaxed">
            {description}
          </p>
        )}

        {children}

        <div className="flex items-center justify-end space-x-2">
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition"
            onClick={onCancel}
            disabled={confirming}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            disabled={busy}
            className={[
              'px-4 py-2 text-sm font-semibold rounded-lg transition',
              confirmColors[tone],
              busy ? 'opacity-50 cursor-not-allowed pointer-events-none' : '',
            ].join(' ')}
            onClick={async (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (busy) return;
              setConfirming(true);
              try {
                if (onConfirm) {
                  const success = await onConfirm();
                  if (success === false) return;
                }
              } catch (error) {
                console.error('Erreur lors de la confirmation:', error);
                return;
              } finally {
                setConfirming(false);
              }
              onCancel?.();
            }}
          >
            {confirming ? 'En cours…' : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
